<app-dialog-container (onClose)="close()">
    <div class="flex flex-col gap-4 md:px-0 sm:px-6">
        <h1 class="text-2xl font-bold text-black space-y-8 sm:space-y-6">{{ job.title }}</h1>

        <div class="overflow-y-auto max-h-[50vh]">
            <dl class="space-y-4 sm:space-y-4 mb-8">
                <div *ngIf="locationString">
                    <dt class="text-sm font-bold sm:w-40 sm:flex-shrink-0" i18n>Location</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">
                        {{ locationString }}
                    </dd>
                </div>
                <div>
                    <dt class="text-sm font-bold sm:w-40 sm:flex-shrink-0" i18n>Role type</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">{{ job.type }}</dd>
                </div>
                <div *ngIf="salaryString">
                    <dt class="text-sm font-bold sm:w-40 sm:flex-shrink-0" i18n>Salary Details</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">{{ salaryString }}</dd>
                </div>
                <div *ngIf="benefitsString">
                    <dt class="text-sm font-bold sm:w-40 sm:flex-shrink-0" i18n>Benefits</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">{{ benefitsString }}</dd>
                </div>
            </dl>
            <div class="text-black space-y-8 sm:space-y-6 prose" *ngIf="job.content" [innerHTML]="job.content.en"></div>
        </div>
    </div>

    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
        <app-apply-button
            [component]="component"
            [job]="job"
            [buttonConfig]="applyButtonConfig"
            (onClick)="dialogRef.close()"></app-apply-button>
        <app-refer-button
            [component]="component"
            [job]="job"
            [buttonConfig]="referButtonConfig"
            (onClick)="dialogRef.close()"></app-refer-button>
        <div class="block md:hidden">
            <button
                (click)="shareJob()"
                class="w-full flex items-center justify-center disabled:bg-blue-300 disabled:text-white/50 disabled:cursor-not-allowed"
                [ngClass]="shareButtonClasses"
                i18n>
                <span class="mat-icon" *ngIf="shareButtonConfig?.icon">{{ shareButtonConfig?.icon }}</span>
                <span>Share Job</span>
            </button>
        </div>
        <div class="hidden md:block">
            <button
                (click)="copyToClipboard()"
                class="w-full flex items-center justify-center disabled:bg-blue-300 disabled:text-white/50 disabled:cursor-not-allowed"
                [ngClass]="shareButtonClasses"
                i18n>
                <span class="mat-icon" *ngIf="shareButtonConfig?.icon">{{ shareButtonConfig?.icon }}</span>
                <span>Share Job</span>
            </button>
        </div>
    </div>
</app-dialog-container>
